/**
 * Árvore de rotas do Tirvu+ web — espelha app/ do expo-router.
 * Grupos "(tabs)" somem da URL (/home, /arquivos...), como no expo-router.
 */
import { definirInstanciaRouter } from "@/navigation";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import AbonoRoute from "./(tabs)/abono";
import ArquivosRoute from "./(tabs)/arquivos";
import AtestadoRoute from "./(tabs)/atestado";
import BiometriaRoute from "./(tabs)/biometria";
import CameraRoute from "./(tabs)/camera";
import ChecklistsRoute from "./(tabs)/checklists";
import EspelhoRoute from "./(tabs)/espelho";
import EstoqueRoute from "./(tabs)/estoque";
import HistoricoRoute from "./(tabs)/historico";
import HomeRoute from "./(tabs)/home";
import JustificativasRoute from "./(tabs)/justificativas";
import LivroOcorrenciaRoute from "./(tabs)/livroOcorrencia";
import MenuRoute from "./(tabs)/menu";
import NotificacoesRoute from "./(tabs)/notificacoes";
import OrdemServicoRoute from "./(tabs)/ordemServico";
import RondaRoute from "./(tabs)/ronda";
import SuporteRoute from "./(tabs)/suporte";
import TabsLayout from "./(tabs)/TabsLayout";
import TreinamentosRoute from "./(tabs)/treinamentos";
import TrocaPlantaoRoute from "./(tabs)/trocaPlantao";
import { RequireColaborador, RequirePrestador, RequireSuporteIdentity } from "./_guards";
import AssinaturaRoute from "./assinatura";
import AtualizacaoCadastralRoute from "./atualizacao-cadastral";
import BiometricSetupRoute from "./biometric-setup";
import CameraDiariaRoute from "./camera-diaria";
import CameraScanRoute from "./camera-scan";
import EntrarRoute from "./entrar";
import EnvironmentSelectRoute from "./environment-select";
import Index from "./index";
import IntroRoute from "./intro";
import MeusDadosPrestadorRoute from "./meus-dados-prestador";
import OnboardingRoute from "./onboarding";
import OnboardingPrestadorRoute from "./onboarding-prestador";
import PermissionsRoute from "./permissions";
import PortalWebRoute from "./portal-web";
import RegistroDiariaRoute from "./registro-diaria";
import RootLayout from "./RootLayout";
import ShellLateral from "./ShellLateral";
import SuporteChatRoute from "./suporte-chat";

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <Index /> },
      // WEB: entrada vinda do "Acesso do Colaborador" do login do TirvuAdm (token no fragmento).
      { path: "/entrar", element: <EntrarRoute /> },
      { path: "/intro", element: <IntroRoute /> },
      { path: "/permissions", element: <PermissionsRoute /> },
      { path: "/environment-select", element: <EnvironmentSelectRoute /> },
      { path: "/onboarding", element: <OnboardingRoute /> },
      { path: "/onboarding-prestador", element: <OnboardingPrestadorRoute /> },
      { path: "/portal-web", element: <PortalWebRoute /> },
      {
        element: <RequireSuporteIdentity />,
        // Desktop: o chat mantém o menu lateral (ShellLateral) e o cabeçalho do app.
        children: [{ element: <ShellLateral />, children: [{ path: "/suporte-chat", element: <SuporteChatRoute /> }] }],
      },
      {
        element: <RequirePrestador />,
        children: [
          { path: "/registro-diaria", element: <RegistroDiariaRoute /> },
          { path: "/camera-diaria", element: <CameraDiariaRoute /> },
          { path: "/meus-dados-prestador", element: <MeusDadosPrestadorRoute /> },
        ],
      },
      {
        element: <RequireColaborador />,
        children: [
          { path: "/biometric-setup", element: <BiometricSetupRoute /> },
          { path: "/camera-scan", element: <CameraScanRoute /> },
          { element: <ShellLateral />, children: [{ path: "/atualizacao-cadastral", element: <AtualizacaoCadastralRoute /> }] },
          { path: "/assinatura", element: <AssinaturaRoute /> },
          {
            element: <TabsLayout />,
            children: [
              { path: "/home", element: <HomeRoute /> },
              { path: "/historico", element: <HistoricoRoute /> },
              { path: "/arquivos", element: <ArquivosRoute /> },
              { path: "/camera", element: <CameraRoute /> },
              { path: "/suporte", element: <SuporteRoute /> },
              { path: "/espelho", element: <EspelhoRoute /> },
              { path: "/atestado", element: <AtestadoRoute /> },
              { path: "/abono", element: <AbonoRoute /> },
              { path: "/notificacoes", element: <NotificacoesRoute /> },
              { path: "/estoque", element: <EstoqueRoute /> },
              { path: "/checklists", element: <ChecklistsRoute /> },
              { path: "/menu", element: <MenuRoute /> },
              { path: "/biometria", element: <BiometriaRoute /> },
              { path: "/justificativas", element: <JustificativasRoute /> },
              { path: "/livroOcorrencia", element: <LivroOcorrenciaRoute /> },
              { path: "/ordemServico", element: <OrdemServicoRoute /> },
              { path: "/ronda", element: <RondaRoute /> },
              { path: "/treinamentos", element: <TreinamentosRoute /> },
              { path: "/trocaPlantao", element: <TrocaPlantaoRoute /> },
            ],
          },
        ],
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

definirInstanciaRouter(router);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
